import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/i18n/LanguageContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import Product from "@/pages/Product";
import Maison from "@/pages/Maison";
import Univers from "@/pages/Univers";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/collection" element={<Collection />} />
              <Route path="/collection/:slug" element={<Product />} />
              <Route path="/maison" element={<Maison />} />
              <Route path="/univers" element={<Univers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "hsl(36 31% 96%)",
              color: "hsl(30 9% 11%)",
              border: "1px solid hsl(34 17% 84%)",
              borderRadius: 0,
              fontFamily: "Inter, sans-serif",
              fontSize: "13px",
              letterSpacing: "0.02em",
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
